import { ReactNode } from 'react';
import { Accordion as BsAccordion } from 'react-bootstrap';

import s from './Accordion.module.scss';

export const AccordionHeader = ({
  title,
  description,
  extra,
}: {
  title: string;
  description: ReactNode;
  extra?: ReactNode;
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        <h3 className="u-bold">{title}</h3>
        <p className="u-color-bark3">{description}</p>
      </div>
      {extra && <div className="me-4">{extra}</div>}
    </div>
  );
};

type Props = {
  items: AccordionItem[];
};

export type AccordionItem = { title: string; description: ReactNode; component: ReactNode; extra?: ReactNode };

export const Accordion = ({ items }: Props) => {
  return (
    <div className={s.customAccordion}>
      <BsAccordion>
        {items.map((item) => {
          const { title, description, component, extra } = item;
          return (
            <BsAccordion.Item key={title} eventKey={title}>
              <BsAccordion.Header>
                <AccordionHeader title={title} description={description} extra={extra} />
              </BsAccordion.Header>
              <BsAccordion.Body>{component}</BsAccordion.Body>
            </BsAccordion.Item>
          );
        })}
      </BsAccordion>
    </div>
  );
};
